export enum MatchRunType {
    Chains = 1,
    Loops = 2,
    ChainsAndLoops = 3
}